export * from './hardcode'

export const CSRF_ENDPOINT = '/sanctum/csrf-cookie'
